<template>
  <div v-if="cartProducts?.length">
    <div class="bg-cart-warning px-4">
      <div :class="percentage ? 'items-center justify-center' : 'justify-between'" class="flex text-xs py-2.5">
        <div class="flex-center gap-1">
          <span v-if="percentage">🎉</span>
          <niceone-price :price="cart.offer" all-side-margin color="#997ADB" html-text/>
        </div>
        <div v-if="!percentage" class="cursor-pointer underline font-niceone-bold" @click="addMore">
          {{ $t('cart.add_more') }}
        </div>
      </div>
    </div>
    <van-progress :percentage="cart.offer_average" :show-pivot="false" color="#CE9ADC" pivot-color="#CE9ADC30"
                  pivot-text="#CE9ADC30" stroke-width="4"/>
  </div>
</template>

<script setup>
import {useScrollToElement} from "@/composables/useScrollToElement";

const {scrollToElement} = useScrollToElement();

import {useCartStore} from '@/store/cart'

const cartStore = useCartStore()
const {cart, cartProducts} = storeToRefs(cartStore)

const addMore = () => {
  scrollToElement('recommended-cart-products');
};
const percentage = computed(() => cart?.value?.offer_average === 100)
</script>

<style></style>